import * as React from "react";
import * as i from "../../../../../contracts";
import { BetBtn } from "../../BetBtn";

export const renderBetButtons = (market: i.Market, betButtonHandler: (market: i.Market, selection: i.Selection) => void, componentPrefix: string) => {
    const selections = market.selections;

    return (
        <div key={`${componentPrefix}__${market.id}`} className={`rj-ev-list__${componentPrefix}__section rj-ev-list__${componentPrefix}__section--${market.template}`} data-uat={`div-ev-list-${componentPrefix}-section`}>
            {selections && selections.map(
                (s, index) => {
                    let betslipModifier = s.isSelectionInBetslip ? "rj-ev-list__bet-btn--chosen" : "";

                    return (
                        <BetBtn
                            key={`${componentPrefix}__bet-btn__${market.id || "m"}-${s && s.id || "s"}-${index}`}
                            isDisabled={s.isDisabled}
                            classNames={`${betslipModifier}`}
                            handler={() => betButtonHandler(market as i.Market, s as i.Selection)}
                            text={s.name}
                            point={s.pointsText}
                            odd={s.odds}
                            trueOdds={s.trueOdds}
                        />
                    )
                }
            )}
        </div>
    );
}